export default function SingleUpArrow({ count = 1 }) {
  return (
    <div className="icon-container">
      {new Array(count).fill("").map((_, i) => (
        <svg
          key={i}
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            d="M16 11V21M11.8334 15.1667L16 11L11.8334 15.1667ZM16 11L20.1667 15.1667L16 11Z"
            stroke="#159900"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="0.75"
            y="0.75"
            width="30.5"
            height="30.5"
            rx="7.25"
            stroke="#0059B1"
            strokeWidth="1.5"
          />
        </svg>
      ))}
    </div>
  );
}
